import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class FullPageService {
  private fullPageStream = new ReplaySubject<boolean>(1);
  isFullPage: Observable<boolean> = this.fullPageStream.asObservable();

  constructor() { }

  enableFullPage() {
    this.fullPageStream.next(true);
  }

  disableFullPage() {
    this.fullPageStream.next(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/full-page.service.ts